export default __webpack_public_path__ + "static/media/12345.ab9cf9f2.png";